<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ detail.name.toUpperCase() }}
              </h4>
              <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="dpt5PoSm5THG13rPVx4lOghnlQMUbjdB6ojtCe3PkhumD1XrC0T9AzotH1GrRlGc"
                />

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="organization_id">Address*</label>
                    <v-select
                      v-model="$v.address.$model"
                      :options="addressesList"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.address.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="">Address Type</label>
                    <ul id="address_type_id" class="checkbox inline">
                      <li>
                        <label for="address_type_id_0"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="service_location"
                            id="address_type_id_0"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Service Location</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_1"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="billing_address"
                            id="address_type_id_1"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Billing Address</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_2"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="headquarters"
                            id="address_type_id_2"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Headquarters</label
                        >
                      </li>
                    </ul>
                    <div
                      v-if="submitted && !$v.address_type.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Button -->
                <div>
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button type="button" class="btn btn-light waves-effect" @click="$router.go(-1)">
                    <!-- <router-link
                      :to="
                        '/mpg/organizations/' + $route.params.id + '/details/'
                      "
                      ></router-link
                    > -->
                    Cancel
                  </button>
                </div>
                <!-- End Button -->
              </form>
              <!-- End Form -->
            </div>
            <!-- End Card Body -->
          </div>
          <!-- End Card -->
        </div>
        <!-- End Col -->
      </div>
    </template>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { addressesService } from '../services/addresses.service'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'AddAddressesFromOrg',
  components: {},
  data () {
    return {
      addressesList: [],
      address_type: [],
      submitted: false,
      loading: true,
      loadingAction: false,
      address: null,
      error: '',
      isEdit: false,
      detail: {}
    }
  },
  validations: {
    address: { required },
    address_type: { required }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/organizations/')
    }

    addressesService
      .getData({
        q: 'q=',
        ordering: '',
        limit: '99999999',
        offset: 0,
        expand: 'state'
      })
      .then((rs) => {
        this.addressesList = rs.results.map((e) => {
          e.label = e.address_street
          e.code = e.address_id
          return e
        })
        this.count = rs.count
        organizationsService.getDataById(this.$route.params.id).then((_rs) => {
          this.detail = _rs
          this.loading = false
          this.addressesList = this.addressesList.filter(e => !this.detail.addresses.find(b => b.address_id === e.code))
        })
      })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loadingAction = true
      const payload = {
        address: this.address.code,
        address_type: this.address_type,
        organization: this.$route.params.id,
        property_status: 'active'
      }
      if (this.isEdit) {
      } else {
        organizationsService.createAddress(payload).then(
          (rs) => {
            this.$nextTick(() => {
              router.push(
                `/mpg/organizations/${this.$route.params.id}/addresses`
              )
            })
          },
          (error) => {
            this.error = error
            this.loadingAction = false
          }
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AddAddressesFromOrg.vue